module.exports = __webpack_public_path__ + "img/my_class_icon.52faa0a9.svg";